import React from 'react';
import { AlertOctagon, AlertTriangle, Info, Bell } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

/** Presentación de las severidades del backend (critica | alta | media | info). */
export const SEVERITY_META = {
  critica: {
    label: 'Crítica',
    variant: 'destructive',
    icon: AlertOctagon,
    dot: 'bg-red-500',
  },
  alta: {
    label: 'Alta',
    variant: 'warning',
    icon: AlertTriangle,
    dot: 'bg-amber-500',
  },
  media: {
    label: 'Media',
    variant: 'info',
    icon: Bell,
    dot: 'bg-blue-500',
  },
  info: {
    label: 'Info',
    variant: 'secondary',
    icon: Info,
    dot: 'bg-slate-400',
  },
};

/** Semáforo de una métrica evaluada contra su parámetro. */
export const METRIC_STATUS_META = {
  ok: {
    label: 'En parámetro',
    className:
      'bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border-emerald-500/30',
  },
  alerta: {
    label: 'En tolerancia',
    className: 'bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/30',
  },
  critico: {
    label: 'Fuera de rango',
    className: 'bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/30',
  },
  sin_meta: {
    label: 'Sin meta',
    className: 'bg-muted text-muted-foreground border-border',
  },
  sin_datos: {
    label: 'Sin datos',
    className: 'bg-muted text-muted-foreground/70 border-border border-dashed',
  },
};

const SeverityBadge = ({ severidad, showIcon = true, className = '' }) => {
  const meta = SEVERITY_META[severidad] || SEVERITY_META.info;
  const Icon = meta.icon;
  return (
    <Badge variant={meta.variant} className={`gap-1 ${className}`}>
      {showIcon && <Icon className="h-3 w-3" />}
      {meta.label}
    </Badge>
  );
};

export default SeverityBadge;
